export function formatDate(date: string) {
  try {
    const dateSplit = date.split('-')
    return `${dateSplit.at(2)}/${dateSplit.at(1)}/${dateSplit.at(0)}`
  } catch (error) {
    return 'Invalid date'
  }
}
